import { useLingui } from '@lingui/react/macro';
import { Joystick } from 'lucide-react';
import useConnectionIndicator from 'modules/overlay-v2/ui/hooks/use-connection-indicator';
import Indicator from 'modules/overlay-v2/ui/components/components/indicator';

function ConnectionIndicator() {
  const { t } = useLingui();
  const { isJoystickActive } = useConnectionIndicator();

  return (
    <Indicator
      text={isJoystickActive ? t`Соединение с джойстиком установленно!` : t`Нет соединения с джойстиком!`}
      icon={<Joystick size={20} />}
      isActive={isJoystickActive}
      style={{ borderRadius: 8, padding: 8 }}
    />
  );
}

export default ConnectionIndicator;
